import React from 'react';
import { Video, FileText } from 'lucide-react';

const CONSENT_CATEGORIES = {
  procedural: { name: 'Surgical & Procedural', icon: 'Scissors', color: 'blue' },
  high_risk: { name: 'High-Risk Procedures', icon: 'AlertTriangle', color: 'red' },
  emergency: { name: 'Emergency Care', icon: 'Activity', color: 'orange' },
  critical_care: { name: 'Critical Care', icon: 'Heart', color: 'pink' },
  end_of_life: { name: 'End of Life Care', icon: 'Shield', color: 'purple' },
  discharge: { name: 'Discharge & LAMA', icon: 'FileSignature', color: 'yellow' },
  refusal: { name: 'Treatment Refusal', icon: 'X', color: 'gray' },
  specialty: { name: 'Specialty Care', icon: 'Stethoscope', color: 'teal' },
  research: { name: 'Research & Trials', icon: 'Brain', color: 'indigo' },
  privacy: { name: 'Data & Privacy', icon: 'Lock', color: 'green' },
  general: { name: 'General Consents', icon: 'FileText', color: 'slate' }
};

// Icon mapping to avoid dynamic imports
import {
  Scissors, AlertTriangle, Activity, Heart, Shield,
  FileSignature, X, Stethoscope, Brain, Lock
} from 'lucide-react';

const ICON_MAP = {
  Scissors, AlertTriangle, Activity, Heart, Shield,
  FileSignature, X, Stethoscope, Brain, Lock, FileText
};

const ConsentTypeSelector = ({ consentTypes, selectedType, onSelect, onNext, patientName }) => (
  <div className="space-y-4">
    <h3 className="text-lg font-semibold text-gray-900">Select Consent Type</h3>
    <p className="text-sm text-gray-600">Choose the type of consent to record for {patientName}</p>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-96 overflow-y-auto">
      {Object.entries(consentTypes).map(([category, types]) => {
        const catInfo = CONSENT_CATEGORIES[category] || { name: category, icon: 'FileText', color: 'gray' };
        const Icon = ICON_MAP[catInfo.icon] || FileText;

        return (
          <div key={category} className="border rounded-lg p-3">
            <div className={`flex items-center gap-2 mb-2 text-${catInfo.color}-700`}>
              <Icon className="h-5 w-5" />
              <span className="font-medium text-sm">{catInfo.name}</span>
            </div>
            <div className="space-y-1">
              {types.map((type) => (
                <button
                  key={type.type}
                  onClick={() => onSelect(type.type)}
                  className={`w-full text-left p-2 rounded text-sm transition-colors ${
                    selectedType === type.type
                      ? 'bg-blue-100 border-blue-500 border'
                      : 'bg-gray-50 hover:bg-gray-100 border border-transparent'
                  }`}
                >
                  <div className="font-medium">{type.name}</div>
                  <div className="text-xs text-gray-500 truncate">{type.description}</div>
                  {type.video_recommended && (
                    <span className="inline-flex items-center text-xs text-green-600 mt-1">
                      <Video className="h-3 w-3 mr-1" /> Video Recommended
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </div>

    <div className="flex justify-end">
      <button
        onClick={onNext}
        disabled={!selectedType}
        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Next: Fill Details
      </button>
    </div>
  </div>
);

export default ConsentTypeSelector;
